
const getPendingDeliveriesQuery = (weeks) => {
  let weekFilter = ''
  if (typeof (weeks) === 'number') {
    weekFilter = `AND s.created_at + '${weeks} week'::INTERVAL >= current_date`
  }

  return `
    with pending_shipments as (
      select
        s.id,
        l1.fsid as destination_id,
        s.origin_id,
        s.status,
        s.shipment_id,
        s.created_at,
        s.updated_at,
        l1.service_start_date,
        l1.market_id as destination_market_id,
        l2.market_id as origin_market_id,
        l1.market_id != l2.market_id as cross_territory_shipment
      from avocado.data_location l1
      left join avocado.data_shipment s on s.destination_id = l1.fsid
      left join avocado.data_location l2 on l2.fsid = s.origin_id
      where s.status != 'received'
        AND l1.uuid = $1
        ${weekFilter}
    ),
    shipment_lines as (
      select
        ps.destination_id,
        ps.shipment_id,
        ps.created_at,
        jsonb_agg(
          jsonb_build_object(
            'sku', cm.sku,
            'quantity', sl.amount,
            'discountAmount', d.discount_amount::float,
            'discountPercentage', d.discount_percentage::float
          )
          order by cm.sku
        ) as lines
      from pending_shipments ps
      left join avocado.data_shipmentline sl on ps.id = sl.shipment_id
      left join avocado.data_productsku sk on sk.old_sku_id = sl.sku
      left join lateral (
        -- Translate SKU between source and tarket market
        select ps2.old_sku_id as sku
        from avocado.data_productsku ps1
        inner join avocado.data_productsku ps2 on ps2.market_id = ps.destination_market_id
                                              and ps2.presentation_id = ps1.presentation_id
        where ps1.old_sku_id = sl.sku
        -- Prefer non discontinued non deleted products by sorting those to the bottom
        -- This works, because false < true
        order by ps2._deleted nulls first,
                 ps2.visibility = 'Discontinued'
        limit 1
      ) cm on true
      left join avocado.discount_item di on di.id = sl.discount_item_id
      left join avocado.discount d on d.id = di.discount_id
      where sl.order_invoicing_type = 'postpaid' and sl.amount > 0
        and (ps.service_start_date is null or sl.created_at > ps.service_start_date)
      group by 1, 2, 3
    ),
    invoice_lines as (
      select
        ps.destination_id,
        ps.shipment_id,
        jsonb_agg(
          jsonb_build_object(
            'sku', il.sku,
            'quantity', il.quantity,
            'discountAmount', d.discount_amount::float,
            'discountPercentage', d.discount_percentage::float
          )
          order by il.sku
        ) as lines
      from pending_shipments ps
      inner join avocado.data_invoice_line il on ps.shipment_id = il.shipment_id
      left join avocado.data_invoice i on i.id = il.invoice_id
      left join avocado.data_invoice_quickbooks iq on iq.invoice_id = i.id
      left join avocado.discount_item di on di.id = il.discount_item_id
      left join avocado.discount d on d.id = di.discount_id
      where il.quantity > 0
      group by 1, 2
    )
    select
      s.destination_id as "locationId",
      s.shipment_id as "shipmentId",
      s.created_at as "createdAt",
      s.lines as "deliveryLines",
      coalesce(i.lines, '[]'::jsonb) as "invoiceLines"
    from shipment_lines s
    left join invoice_lines i on s.destination_id = i.destination_id and s.shipment_id = i.shipment_id
  `
}

module.exports = {
  getPendingDeliveriesQuery
}
